module.exports = __webpack_public_path__ + "static/img/lian-purse.fc67424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lian-purse.png
// module id = 7Nd4
// module chunks = 2